export const companies = [
  {
    name: "GCG Media",
    description: "A Dubai-based agency helping brands scale with performance media buying and ad optimization.",
    image: "GCG Media.png"
  }
  ,
  {
    name: "LTVX.ai",
    description: "AI-powered platform that turns declined payments into revenue.",
    image: "LTVX.png"
  },
  // {
  //   name: "8Decimals",
  //   description: "Crypto hedge fund",
  //   image: "8Decimals.png"
  // },
  {
    name: "DRESS",
    description: "Private Real Estate Fund",
    image: "DRESS.png"
  },
  {
    name: "GCGRe",
    description: "Private real estate fund in the USA",
    image: "GCGRe.png"
  },
  {
    name: "Magnetic",
    description: "AI tax preparation for CPAs",
    image: "Magnetic.png"
  },
  {
    name: "Reacher",
    description: "We help brands scale creator partnerships 10x faster",
    image: "Reacher.png"
  },
  {
    name: "Pally",
    description: "Pally is an AI Relationship Management Platform",
    image: "Pally.png"
  },
  {
    name: "StarSling",
    description: "Cursor for DevOps",
    image: "StarSling.png"
  },
  {
    name: "Propolis",
    description: "Hands off QA via intelligent browser agents.",
    image: "Propolis.png"
  },
  {
    name: "MindFort",
    description: "Autonomous Security Agents",
    image: "MindFort.png"
  },
  {
    name: "Hemut",
    description: "AI-powered operating system for trucking companies.",
    image: "Hemut.png"
  },
  {
    name: "Eloquent AI",
    description: "The AI Operator for Financial Services",
    image: "Eloquent AI.png"
  },
  {
    name: "MorphoAI",
    description: "Software tool for designing robots and machines",
    image: "MorphoAI.png"
  },
  {
    name: "Vassar Robotics",
    description: "Ultra-affordable robots that are practical and accessible today.",
    image: "Vassar Robotics.png"
  },
  {
    name: "Third Chair",
    description: "Agents for in-house legal teams",
    image: "Third Chair.png"
  },
  {
    name: "Novoflow",
    description: "AI employees that automate medical operations for clinics.",
    image: "Novoflow.png"
  },
  {
    name: "throxy",
    description: "Vertical AI agents that run the sales funnel on autopilot",
    image: "throxy.png"
  },
  {
    name: "HABIT",
    description: "Reshaping neighborhood services with robotics.",
    image: "HABIT.png"
  },
  {
    name: "Combinely",
    description: "AI coworker for accountants",
    image: "Combinely.png"
  },
  {
    name: "Attune",
    description: "Faster builds, zero effort.",
    image: "Attune.png"
  },
  {
    name: "PgDog",
    description: "Scaling engine for PostgreSQL",
    image: "PgDog.png"
  },
  {
    name: "Claim Health",
    description: "The first AI revenue platform for post-acute healthcare",
    image: "Claim Health.png"
  },
  {
    name: "Anvil",
    description: "Anvil is the SEO platform for the AI era",
    image: "Anvil.png"
  },
  {
    name: "Cua",
    description: "Docker for Computer-use Agents",
    image: "Cua.png"
  },
  {
    name: "GroundControl",
    description: "Vertical AI for highly-regulated manufacturing",
    image: "GroundControl.png"
  },
  {
    name: "Bloom",
    description: "Build and share mobile apps in seconds",
    image: "Bloom.png"
  },
  {
    name: "cubic",
    description: "AI-powered code review platform",
    image: "cubic.png"
  },
  {
    name: "nao Labs",
    description: "Cursor for data teams.",
    image: "nao Labs.png"
  },
  {
    name: "Aravolta",
    description: "Software to monitor, control, and optimize data centers.",
    image: "Aravolta.png"
  },
  {
    name: "Plexe",
    description: "Open-source agents to build predictive ML models from a prompt",
    image: "Plexe.png"
  },
  {
    name: "Chestnut",
    description: "The first AI mortgage lender",
    image: "Chestnut.png"
  },
  {
    name: "QFEX",
    description: "24/7 Global Stock Exchange",
    image: "QFEX.png"
  },
  {
    name: "Mentra",
    description: "Building the open source smart glasses operating system.",
    image: "Mentra.png"
  },
  {
    name: "Fira",
    description: "Agentic AI platform for investment firms",
    image: "Fira.png"
  },
  {
    name: "Artifact",
    description: "An Collaborative, AI-native IDE for Hardware Engineers",
    image: "Artifact.png"
  },
  {
    name: "ThirdLayer",
    description: "Building Dex, the AI Browser Copilot",
    image: "ThirdLayer.png"
  },
  {
    name: "Tally",
    description: "AI accounting",
    image: "Tally.png"
  },
  {
    name: "SAMMY Labs",
    description: "Live, AI-powered graph of every possible click path in your software",
    image: "SAMMY Labs.png"
  },
  {
    name: "Mercura",
    description: "AI Quoting for distributors and manufacturers",
    image: "Mercura.png"
  },
  {
  name: "Zora",
  description: "Decentralized platform for minting and trading on-chain media and NFTs",
  image: "Zora.png"
}

]; 